<template>
  <div class="tab-bar">
    <div class="tab-left">
      <div class="tab-title h2">{{ title }}</div>
      <div class="tab-desc h4">{{ desc }}</div>
    </div>
    <div class="tab-right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleTab",
  props: ["title", "desc"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@style/base";
.tab-bar {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .tab-left {
    .tab-title+.tab-desc {
      margin-top: 7px;
    }
  }
  .tab-right {
    flex-shrink: 0;
  }
}
</style>
